<div nz-row>
	<div nz-col nzXs="24" nzSm="12">
		<div>
			<span class="semibold fs-14">Email - </span>
			<span class="fs-14 ml-5">{{ user?.fUsername }}</span>
		</div>
		<div class="mt-10">
			<span class="semibold fs-14">Mobile - </span>
			<span class="fs-14 ml-5">{{ user?.fCountryCode }} {{ user?.fMobile }}</span>
		</div>
		<div class="mt-10">
			<span class="semibold fs-14">Staff Username - </span>
			<span class="fs-14 ml-5">{{ user?.staff_username }}</span>
		</div>
		<div class="mt-10">
			<span class="semibold fs-14">First Name - </span>
			<span class="fs-14 ml-5">{{ user?.fFirstName }}</span>
		</div>
		<div class="mt-10">
			<span class="semibold fs-14">Last Name - </span>
			<span class="fs-14 ml-5">{{ user?.fLastName }}</span>
		</div>
		<div class="mt-10">
			<span class="semibold fs-14">[Legacy] Name - </span>
			<span class="fs-14 ml-5">{{ user?.fName }}</span>
		</div>
		<div class="mt-10">
			<span class="semibold fs-14">Address - </span>
			<span class="fs-14 ml-5">{{ user?.fAddress }}</span>
		</div>
	</div>
	<div nz-col nzXs="24" nzSm="12">
		<form nz-form [formGroup]="form" nzLayout="vertical">
			<nz-form-item>
				<nz-form-label nzRequired nzFor="password">New Password</nz-form-label>
				<nz-form-control>
				  <input nz-input formControlName="password" id="password">
				</nz-form-control>
			</nz-form-item >
		</form>
		<div>
			<button nz-button nzType="primary" (click)="generatePassword()">
				<span nz-icon nzType="reload" nzTheme="outline"></span> 
				Generate
			</button>
		</div>
	</div>
</div>
<div *nzModalFooter>
	<button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
	<button nz-button nzType="primary"
		[disabled]="form.invalid"
		[nzLoading]="loading"
		(click)="reset()"
	>Reset</button>
</div>